import React from 'react';
import { IconBase } from '../Base';
export const IconBars = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M10 12.5V6.66667M6.66667 9.07334V12.5M13.3333 12.5V10.2167M6.66667 2.5H13.3333C15.6345 2.5 17.5 4.36548 17.5 6.66667V13.3333C17.5 15.6345 15.6345 17.5 13.3333 17.5H6.66667C4.36548 17.5 2.5 15.6345 2.5 13.3333V6.66667C2.5 4.36548 4.36548 2.5 6.66667 2.5Z", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Bars.js.map